import { render, staticRenderFns } from "./DiseaseInfoAdd.vue?vue&type=template&id=576c49a9&scoped=true&"
import script from "./DiseaseInfoAdd.vue?vue&type=script&lang=js&"
export * from "./DiseaseInfoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c49a9",
  null
  
)

export default component.exports